import * as React from "react";
import { forwardRef } from "react";
const SvgZoomOut = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-zoom-out-icon lucide-zoom-out", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 11, r: 8 }), /* @__PURE__ */ React.createElement("line", { x1: 21, x2: 16.65, y1: 21, y2: 16.65 }), /* @__PURE__ */ React.createElement("line", { x1: 8, x2: 14, y1: 11, y2: 11 }));
const ForwardRef = forwardRef(SvgZoomOut);
export default ForwardRef;
